import React from 'react';
import { Copy, Link } from '@grubhubprod/gh-cookbook-react';
import { GroceriesLegalLinks } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';

interface GroceriesHeroDisclaimerProps {
  brandDisplayName: string;
  legalLinks: GroceriesLegalLinks;
}

export function GroceriesHeroDisclaimer({
  brandDisplayName,
  legalLinks,
}: GroceriesHeroDisclaimerProps): JSX.Element {
  return (
    <Copy variant="caption" color="secondaryText">
      By continuing, you agree to {brandDisplayName} (
      <Link
        href={legalLinks.grubhubTerms}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </Link>
      {' & '}
      <Link
        href={legalLinks.grubhubPrivacy}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </Link>
      ) and Instacart (
      <Link
        href={legalLinks.instacartTerms}
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </Link>
      {' & '}
      <Link
        href={legalLinks.instacartPrivacy}
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </Link>
      ) policies and{' '}
      <Link
        href={legalLinks.infoSharing}
        target="_blank"
        rel="noopener noreferrer"
      >
        info sharing
      </Link>
      .
    </Copy>
  );
}
